// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.area[data-v-837f6e72] {\n  width: 100%;\n  max-width: 445px;\n}\n.area-info[data-v-837f6e72] {\n  background: #ffffff;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
